import React from 'react';
import LocationTemplate from './LocationTemplate';

const WallacePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Wallace"
      stateName="North Carolina"
      countyName="Duplin"
      zipCodes={["28466"]}
      latitude={34.7354}
      longitude={-77.9972}
      population={3880}
      historicalFact="Named after Stephen D. Wallace, who sold land to the railroad in the 1800s."
      nearbyTowns={[
        "Rose Hill, NC",
        "Warsaw, NC",
        "Magnolia, NC",
        "Teachey, NC",
        "Chinquapin, NC",
        "Kenansville, NC",
        "Turkey, NC",
        "Burgaw, NC"
      ]}
    />
  );
};

export default WallacePage;